import { Download } from "@mui/icons-material";
import {
  IconButton,
  Link,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { downloadCSV } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatAccountNumber from "../../unit/formatAccountNumber";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
const TableCellRight = styled(TableCell)({ textAlign: "right" });

const downloadTransactionFile = (account_id: any) => {
  let reqUrl = "customers/downloadTransaction";
  const fetchData = async () => {
    const responseData = await sendRequest(reqUrl, { id: account_id });
    if (responseData) {
      let data = responseData.data;

      let downloadData: {
        UID: any;
        AccountID: any;
        AccountType: any;
        TransactionID: any;
        Name: any;
        Amount: any;
        Date: any;
        MainCategory: any;
        Category: any;
        SubCategory: any;
        Keywords: any;
        Functions: any;
        PlaidCategory: any;
      }[] = [];
      data.forEach((item: any) => {
        console.log("item ==>", item);
        let downloadItem = {
          UID: item.uid,
          AccountID: item.account_id,
          AccountType: item.type,
          TransactionID: item.id,
          Name: item.sname,
          Amount: item.amount,
          Date: item.sdate,
          MainCategory: item.main_category,
          Category: item.category,
          SubCategory: item.sub_category,
          Keywords: item.applied_keywords,
          Functions: item.applied_condition,
          PlaidCategory: item.attribute_value,
        };
        downloadData.push(downloadItem);
      });
      const csvTitle = Object.keys(downloadData[0]).join(",");
      const csvDataStr = downloadData
        .map((item) =>
          Object.values(item)
            .map((val) => `"${val}"`)
            .join(",")
        )
        .join("\n");
      const csvBody = csvTitle + "\n" + csvDataStr;
      downloadCSV(csvBody, "transaction_data");
    }
  };
  fetchData();
};
const CustomSummaryAccountList = ({ ...props }) => {
  const userId = props.userId;
  const plaidAccountList = props.plaidAccountList ? props.plaidAccountList : [];
  const plaidAccount = props.plaidAccount ? props.plaidAccount : [];
  const paymentAccountData = props.paymentAccountData
    ? props.paymentAccountData
    : [];

  return (
    <div key={"customsummaryaccount" + userId}>
      {/* <IconButton
        aria-label="download"
        component={Link}
        onClick={() => downloadTransactionFile(7951)}
        target="_blank"
        rel="noreferrer"
      >
        <Download />
      </IconButton> */}
      <CustomTableContainer commponent={CustomPaper}>
        <CustomTable
          key={"financial_account_connected" + userId}
          stickyHeader
          id="table-customer-summary-account-list"
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Date Added
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Last Download
              </TableCell>
              <TableCell sx={{ width: "150px" }} className="hm-table-header">
                Account Number
                <br />
                (Last 4 Digits)
              </TableCell>
              <TableCell className="hm-table-header">Institution</TableCell>
              <TableCell className="hm-table-header">Account Type</TableCell>
              <TableCell align="right" className="hm-table-header">
                Account Balance
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Account Balance Current
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Transaction Start Date
              </TableCell>
              {/* <TableCell>Transaction End Date</TableCell> */}
              <TableCell className="hm-table-header">Status</TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Date Removed
              </TableCell>
              <TableCell className="hm-table-header">Download</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {plaidAccountList == undefined ||
            plaidAccountList.length == 0 ||
            plaidAccountList == null ? (
              <TableRow>
                <TableCell colSpan={8}>No Transaction account </TableCell>
              </TableRow>
            ) : (
              plaidAccountList?.map((item: any) => (
                <TableRow
                  key={
                    `csal_` +
                    item.iApplicationId +
                    `_` +
                    item.id +
                    `_` +
                    item.meta_number +
                    `_` +
                    item.account_status
                  }
                >
                  <TableCell sx={{ width: "120px" }}>
                    {formatDate(item.created_at)}
                  </TableCell>
                  <TableCell sx={{ width: "120px" }}>
                    {formatDate(item.download_time)}
                  </TableCell>
                  <TableCell>{formatAccountNumber(item.meta_number)}</TableCell>
                  <TableCell>{item.sTitle}</TableCell>
                  <TableCell>{item.type}</TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.balance_available)}
                  </TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.balance_current)}
                  </TableCell>
                  <TableCell sx={{ width: "120px" }}>
                    {formatDate(item.transaction_start)}
                  </TableCell>
                  {/* <TableCell>{formatDate(item.transaction_end)}</TableCell> */}
                  <TableCell>{item.account_status}</TableCell>
                  <TableCell sx={{ width: "120px" }}>
                    {item.removed_at && item.removed_at != "0000-00-00 00:00:00"
                      ? item.removed_at.replace(
                          /(\d{2})\/(\d{2})\/(\d{4})/,
                          "$3-$1-$2"
                        )
                      : ""}
                  </TableCell>
                  <TableCell>
                    {/* download icon */}
                    <IconButton
                      aria-label="download"
                      component={Link}
                      onClick={() => downloadTransactionFile(item.id)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Download />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </div>
  );
};

export default CustomSummaryAccountList;
